import { render } from "./details.vue?vue&type=template&id=33560f6a&scoped=true&ts=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=33560f6a&lang=scss&scoped=true"
import "./details.vue?vue&type=style&index=1&id=33560f6a&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33560f6a"]])

export default __exports__